export default __webpack_public_path__ + "static/media/favicon.8a4a0466.png";